import { auth } from "../../../firebase/firebase";
import "./LogoutButton.css";
const LogoutButton = () => {
  const handleLogout = async () => {
    await auth.signOut();
    localStorage.removeItem("loginTime");
    window.location.href = "/admin/login";
  };

  return (
    <div className="logout-container">
      <button className="logout-button" onClick={handleLogout}>
        Cerrar sesión
      </button>
    </div>
  );
};

export default LogoutButton;
